import { connect } from 'react-redux'
import HeadMetadata from 'Shared/HeadMetadata/HeadMetadata'

const mapStateToProps = ({ metadata }) => ({ ...metadata })

export default connect(mapStateToProps)(HeadMetadata)



// WEBPACK FOOTER //
// ./src/Shared/HeadMetadata/HeadMetadataContainer.js